import { request } from '@umijs/max';
import { getNebulithUserApiUrl } from '@/services/util';

export async function loginSso(
  params?: USERS.LoginSsoParams,
  options?: { [key: string]: any },
) {
  return request<USERS.LoginSsoResponse>(
    getNebulithUserApiUrl('auth/login-sso'),
    {
      method: 'GET',
      params: {
        provider: params?.provider,
        redirectUri: params?.redirectUri,
      },
      ...(options || {}),
    },
  );
}

/** SSO / 登录态用户信息 */
export async function getAuthUserInfo(options?: { [key: string]: any }) {
  return request<USERS.AuthUserInfo>(getNebulithUserApiUrl('auth/userinfo'), {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录 */
export async function logout(options?: { [key: string]: any }) {
  return request<Record<string, any>>(getNebulithUserApiUrl('auth/logout'), {
    method: 'POST',
    ...(options || {}),
  });
}

/** 发送邮箱验证码 */
export async function sendEmailCode(
  body: USERS.SendEmailCodeParams,
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(
    getNebulithUserApiUrl('register/send-email-code'),
    {
      method: 'POST',
      data: body,
      ...(options || {}),
    },
  );
}

/** 用户注册 */
export async function register(
  body: USERS.RegisterParams,
  options?: { [key: string]: any },
) {
  return request<USERS.LoginResult>(
    getNebulithUserApiUrl('register/create'),
    {
      method: 'POST',
      data: body,
      ...(options || {}),
    },
  );
}

